import React from "react";

export const SearchingEpImage: React.FC = () => {
  return (
    <div>
      <img
        src="searching-ep-coverphoto.jpeg"
        alt="Man looking into the camera on a pier"
        width="300"
      />
    </div>
  );
};
